<template>
  <ContentSection :spacing="conditionalSpacing">
    <Container
      :indent="isSustainabilityArticleWithSidebar ? 'none' : 'center'"
      class="flex flex-col md:flex-row"
    >
      <AppImage
        v-if="data.portrait_image"
        :src="data.portrait_image"
        :alt="
          $i18n.locale === 'fr'
            ? data.portrait_image.alt_fr
            : data.portrait_image.alt
        "
        class="-mt-5 mb-4 hidden aspect-[204/272] w-40 shrink-0 rounded-sm object-cover lg:inline-block lg:w-[12.75rem]"
        :aspect-ratio="204 / 272"
        :style="`object-position: ${data.portrait_image.focus_css};`"
        loading="lazy"
      />

      <div class="flex items-start text-lg">
        <div class="max-w-[2.8125rem] shrink-0">
          <QuoteIcon class="mr-5 mt-[0.35em] h-[1.2em] w-full text-blue-800" />
        </div>

        <figure>
          <blockquote class="max-w-text font-medium">
            {{ data.quote }}
          </blockquote>

          <div class="mt-8 flex">
            <div>
              <AppImage
                v-if="data.portrait_image"
                :src="data.portrait_image"
                :alt="
                  $i18n.locale === 'fr'
                    ? data.portrait_image.alt_fr
                    : data.portrait_image.alt
                "
                class="mr-4 aspect-[2/3] w-16 min-w-24 shrink-0 rounded-sm object-cover lg:hidden"
                :aspect-ratio="1 / 1"
                :style="`object-position: ${data.portrait_image.focus_css};`"
                loading="lazy"
              />
            </div>
            <figcaption>
              <div>
                <p class="font-medium">{{ data.author }}</p>
                <p>{{ data.job_title }}</p>
              </div>
            </figcaption>
          </div>
        </figure>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})

const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
  ['custom_text']
)
</script>

<style scoped>
blockquote:after {
  content: '';
  background-image: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.736 32.456"> <path id="Path_835" data-name="Path 835" d="M15.779,6.373c-6.225,4-9.247,8.12-9.247,15.011a3.547,3.547,0,0,1,1.127-.128,6.11,6.11,0,0,1,6.4,6.173c0,4.124-2.638,6.686-6.4,6.686C2.792,34.116,0,30.222,0,23.229,0,13.495,4.483,6.5,12.859,1.66Zm17.931,0c-6.225,4-9.247,8.12-9.247,15.011a3.547,3.547,0,0,1,1.127-.128,6.11,6.11,0,0,1,6.4,6.173c0,4.124-2.638,6.686-6.4,6.686-4.841,0-7.634-3.894-7.634-10.887,0-9.734,4.483-16.727,12.859-21.569l2.92,4.713Z" transform="translate(33.736 34.116) rotate(180)" fill="%230091d2" fill-rule="evenodd"/> </svg>');
  height: 1.2em;
  @apply w-6 md:w-8 bg-no-repeat align-text-bottom;
}

blockquote:after {
  left: 0.5em;
  @apply inline-block relative top-[0.5em];
}
</style>
